<template>
   <div class="citypartnercspm">
      <div class="CRMapsel">
          {{$t('message.partner')}}：
           <!-- <select-menu :partData="partData" @change="changeHandler"></select-menu> -->
            <el-select v-model="valuePa" placeholder="请选择" @change="changeHandler" class="selectCss" filterable>
                <el-option
                v-for="(item,index) in partData"
                :key="index"
                :label="item.loginName"
                :value="item.partnerNo">
                </el-option>
          </el-select>
          {{$t('message.area')}}：
          <!-- <select-men :areaData="areaData"></select-men> -->
           <el-select v-model="valueAr" placeholder="请选择" @change="changeArea" class="selectCss" filterable>
            <el-option
                v-for="(item,index) in areaData"
                :key="index"
                :label="item.Partnerareaname"
                :value="item.partnerareaguid">
            </el-option>
         </el-select>
           <el-dropdown style="color:#000" @command="userOperation" class="dropName">
                <span class="user">{{this.$cookies.get("LoginName")}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                <el-dropdown-menu slot="dropdown" class="dropst">
                    <el-dropdown-item command="editPsd">{{$t('message.changePSD')}}</el-dropdown-item>
                        <!-- <el-dropdown-item command="editSecPsd">{{$t('message.changeSecPSD')}}</el-dropdown-item> -->
                    <el-dropdown-item command="logout">{{$t('message.exit')}}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <!-- <lang-select class="drops" @handIt="loadAgain"></lang-select> -->
       <header style="margin-top: 6%;">
           <el-form :inline="true" :model="formInline" class="demo-form-inline flex">
                <el-form-item label="姓名">
                    <el-input v-model="formInline.newUserRealName" placeholder="请输入姓名查询"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="formInline.employeePhone" placeholder="请输入手机号查询"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="serch">查询</el-button>
                </el-form-item>
                <el-button class="marginleft add" size="medium" icon="el-icon-circle-plus" type="primary" @click="add">新增账户</el-button>
            </el-form>
       </header>
       <el-tabs v-model="activeName" type="border-card" @tab-click="tabchange">
            <el-tab-pane name="1" label="使用中">
                <el-table
                    :data="useData"
                    stripe
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        label="编号"
                        type="index"
                        min-width="80">
                    </el-table-column>
                    <el-table-column
                        prop="OperationTime"
                        label="申请日期"
                        min-width="80">
                    </el-table-column>
                    <el-table-column
                        prop="AccountName"
                        label="账号"
                        min-width="80">
                    </el-table-column>
                    <el-table-column
                        prop="UserRealName"
                        label="姓名"
                        min-width="80">
                    </el-table-column>
                    <el-table-column
                        prop="UserPhone"
                        label="手机号"
                        min-width="80">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        >
                        <template slot-scope="scope">
                            <el-button @click="edit(scope.row)" type="primary" size="small">修改密码</el-button>
                            <!-- <el-button @click="power(scope.row)" type="warning" size="small">权限配置</el-button> -->
                            <el-button type="danger" @click="enableORdisableStaff(-1,scope.row)" size="small">禁用</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    style="float:right;margin-top:1%"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pagination.index"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="pagination.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane name="-1" label="已禁用">
                <el-table
                    :data="NouseData"
                    stripe
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        label="编号"
                        type="index"
                        min-width="120">
                    </el-table-column>
                    <el-table-column
                        prop="OperationTime"
                        label="申请日期"
                        min-width="100">
                    </el-table-column>
                    <el-table-column
                        prop="AccountName"
                        label="账号"
                        min-width="100">
                    </el-table-column>
                    <el-table-column
                        prop="UserRealName"
                        label="姓名"
                        min-width="100">
                    </el-table-column>
                    <el-table-column
                        prop="UserPhone"
                        label="手机号"
                        min-width="100">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作">
                        <template slot-scope="scope">
                            <el-button @click="enableORdisableStaff(1,scope.row)" type="primary" size="small">启用</el-button>
                            <el-button type="danger" @click="del(scope.row)" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    style="float:right;margin-top:1%"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pagination.index"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="pagination.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total">
                </el-pagination>
            </el-tab-pane>
       </el-tabs>
       <el-dialog title="新增账户" :visible.sync="addinfo.show">
            <el-form ref="form" :rules="rules" :model="addinfo.form" label-suffix="：" label-width="80px">
                <el-form-item label="账号" prop="newAccountName">
                    <el-input type="text" placeholder="请输入登录系统的账号" v-model="addinfo.form.newAccountName"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input  type="password" placeholder="请输入登录系统的密码" v-model="addinfo.form.password"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="newUserRealName">
                    <el-input placeholder="请输入账户真实姓名" v-model="addinfo.form.newUserRealName"></el-input>
                </el-form-item>
                <el-form-item label="身份证" prop="idCardNO">
                    <el-input type="idCard" placeholder="请输入账户身份证号码" v-model="addinfo.form.idCardNO"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="employeePhone">
                    <el-input type="number" placeholder="请输入账户手机号码" v-model="addinfo.form.employeePhone"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addinfo.show = false">取 消</el-button>
                <el-button type="primary" @click="addok">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改账户" :visible.sync="editinfo.show">
            <el-form ref="form2" :rules="rules2" :model="editinfo.form" label-suffix="：" label-width="80px">
                <el-form-item label="新密码" prop="password">
                    <el-input  type="password" placeholder="请输入新密码" v-model="editinfo.form.password"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editinfo.show = false">取 消</el-button>
                <el-button type="primary" @click="edditok">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="账户权限配置" :visible.sync="Userpower.show">
            <el-tree
                :data="Userpower.data"
                show-checkbox
                node-key="id"
                default-expand-all
                highlight-current
                @check-change="getNodeKey"
                :default-checked-keys="Userpower.defaultkeys">
            </el-tree>
            <div slot="footer" class="dialog-footer">
                <el-button @click="Userpower.show = false">取 消</el-button>
                <el-button type="primary" @click="Userpowerok">确 定</el-button>
            </div>
        </el-dialog>
   </div>
</template>

<script>
   import md5 from "js-md5";
   import base from '@/utils/base64'  //引入
//    let Base64 = require('js-base64').Base64;
let chechval = []
   export default {
        data() {
            return {
                formInline: {
                    newUserRealName: '',
                    employeePhone: ''
                },
                addinfo:{
                    show:false,
                    form:{
                        myLord:'',
                        password:'',
                        newAccountName:'', // 登录系统的账号
                        newAccountLoginPWD:'', //登录系统的密码
                        newUserRealName:'', // 真实姓名
                        partnerGuid:'', // 运营区域id
                        idCardNO:'', //用户身份证
                        employeePhone:'', // 用户电话
                    },
                },
                editinfo:{
                    show:false,
                    form:{
                        newAccountLoginPWD:'',
                        password:'',
                    },
                },
                rules:{
                   newAccountName:[
                     { required: true, message: '请输入账号', trigger: 'blur' }
                   ],
                   password:[
                    { required: true, message: '请输入密码', trigger: 'blur' }
                   ],
                   newUserRealName:[
                    { required: true, message: '请输入真实姓名', trigger: 'blur' }
                   ],
                   idCardNO:[
                    { required: true, message: '请输入身份证号码', trigger: 'blur' }
                   ],
                   employeePhone:[
                    { required: true, message: '请输入用户手机号码', trigger: 'blur' }
                   ]
                },
                Userpower:{
                    show:false,
                    data: [],
                    form:{
                        userRealName:'', // 如果editMPType 为1时，这个值就是个人的真实姓名
                        newMenuPermissionIDs:[], //所选中的菜单ID列表
                        editMPTypeVal:'', // 如果editMPType 为1时，这个值就是个人的perationUserGuid,如果是2的话，就是角色值:3代表合伙人客服 4代表财务
                    },
                    defaultkeys:[],
                },
                rules2:{
                   password:[
                    { required: true, message: '请输入新密码', trigger: 'blur' }
                   ],
                },
                pagination:{
                    total:100,
                    index:0,
                    size:10,
                },
                NouseData:[],
                useData:[],
                activeName:'1',
                valuePa: "",
                valueAr: "",
                partData: [],
                areaData: [],
                formm: {
                    oldpsd: "",
                    newpsd: "",
                    surepsd: ""
                },

            }
        },
        created() {
            this.customerServiceList()
            this.loadPartner()
        },
        methods: {
            changeHandler() {
                this.$cookies.set("partner", this.valuePa);
                this.loadArea();
            },
            changeArea() {
               // this.$cookies.set("partner", this.valuePa);
               this.$cookies.set("areaValue", this.valueAr);
            },
            del(itme){
                this.$confirm('是否删除该账户?', "删除", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        let base1 = new base();
                        var params = new URLSearchParams(); 
                        let myLord = this.$cookies.get("LoginName") +'|'+ this.$cookies.get("pwd")+'|'+ parseInt(new Date().getTime()/1000)+'|'+Math.round(Math.random()*100)+'|'+"a782@#@DfwVzZz~~25"
                        params.append("myLord", base1.encode(myLord));
                        params.append("perationUserGuid", itme.PerationUserGuid);
                        params.append("userRealName", itme.UserRealName);
                        this.$axios({
                            url: "http://139.224.204.55:7788/tlwewebapi/CityPartner/physicalDeletionStaff",
                            method: "post",
                            data: params,
                            withCredentials: false
                        }) .then(res => {
                            let ndata = res.data
                            if(ndata.status == 'success'){
                                this.$message({
                                    message: ndata.message,
                                    type: "success"
                                });
                                this.customerServiceList()
                            }else{
                                this.$message.error(ndata.message);
                            }
                        })
                    })
            },
            edit(itme){
                this.editinfo={
                    show:true,
                    form:{
                        myLord:'',
                        perationUserGuid:itme.PerationUserGuid,
                        userRealName:itme.UserRealName,
                        newAccountLoginPWD:'',
                        password:'',
                    },
                }
            },
            edditok(){
                this.$refs.form2.validate((valid) => {
                    if (valid) {
                        let base1 = new base();
                        this.editinfo.form.newAccountLoginPWD = md5( this.editinfo.form.password)
                        let myLordstring = this.$cookies.get("LoginName") +'|'+ this.$cookies.get("pwd")+'|'+ parseInt(new Date().getTime()/1000)+'|'+Math.round(Math.random()*100)+'|'+"V1+V3=?ITIS7758258V4"
                        this.editinfo.form.myLord = base1.encode(myLordstring)
                        var params = new URLSearchParams();
                        params.append("myLord", this.editinfo.form.myLord);
                        params.append("perationUserGuid", this.editinfo.form.perationUserGuid);
                        params.append("userRealName", this.editinfo.form.userRealName);
                        params.append("newAccountLoginPWD", this.editinfo.form.newAccountLoginPWD);
                        this.$axios({
                            url: "http://139.224.204.55:7788/tlwewebapi/CityPartner/editStaffLoginPWD",
                            method: "post",
                            data: params,
                            withCredentials: false
                        }) .then(res => {
                            let ndata = res.data
                            if(ndata.status == 'success'){
                                this.$message({
                                    message: ndata.message,
                                    type: "success"
                                });
                                this.editinfo.show= false
                                this.customerServiceList()
                            }else{
                                this.$message.error(ndata.message);
                            }
                        })
                    }else{

                    }
                })
            },
            power(itme){
                let base1 = new base();
                var params = new URLSearchParams();
                let myLord = this.$cookies.get("LoginName") +'|'+ this.$cookies.get("pwd")+'|'+ parseInt(new Date().getTime()/1000)+'|'+Math.round(Math.random()*100)+'|'+"AdSvdgfvvvvv!~xyY"
                params.append("myLord", base1.encode(myLord));
                params.append("showMPTypeVal", itme.PerationUserGuid);
                params.append("showMPType", 1);
                params.append("partnerGuid", this.valuePa);
                this.$axios({
                    url: "http://139.224.204.55:7788/tlwewebapi/CityPartner/showMenuPermission",
                    method: "post",
                    data: params,
                    withCredentials: false
                }).then(res => {
                   let ndata = res.data
                   if(ndata.status == "success"){
                        this.Userpower = {
                            show:true,
                            data:ndata.data,
                            form:{
                                userRealName:'', // 如果editMPType 为1时，这个值就是个人的真实姓名
                                newMenuPermissionIDs:[], //所选中的菜单ID列表
                                editMPTypeVal:'', // 如果editMPType 为1时，这个值就是个人的perationUserGuid,如果是2的话，就是角色值:3代表合伙人客服 4代表财务
                            },
                            defaultkeys:[],
                        }
                        ndata.data.forEach(o =>{
                            if(o.isselect == "YES"){
                               this.Userpower.defaultkeys.push(o.id)
                               this.Userpower.form.newMenuPermissionIDs.push(o.id)
                               o.children.forEach(y =>{
                                  if(y.isselect == "YES"){
                                     this.Userpower.defaultkeys.push(y.id)
                                     this.Userpower.form.newMenuPermissionIDs.push(y.id)
                                  }
                               })
                            }
                           
                        })
                        console.log(this.Userpower.form.newMenuPermissionIDs)
                        this.Userpower.form.userRealName = itme.UserRealName
                        this.Userpower.form.editMPTypeVal = itme.PerationUserGuid 
                   }   
                })
            },
            logout() {
                this.$cookies.set("SaveSiaLog", 2);
                this.$router.push("./login");
            },
            getNodeKey(data, checked){
                // this.Userpower.form.newMenuPermissionIDs = []
                let newMenuPermissionIDs = this.Userpower.form.newMenuPermissionIDs
                this.Userpower.data.forEach(o =>{
                    if(o.children.length>0){
                        o.children.forEach(s =>{
                            if(s.id == data.id && checked){
                                newMenuPermissionIDs.push(s.id)
                                //    this.Userpower.form.newMenuPermissionIDs.push(o)  
                            }else if(s.id == data.id && !checked){
                               newMenuPermissionIDs.splice(newMenuPermissionIDs.findIndex(item => item == data.id), 1)
                            }
                        })
                    }
                })
                console.log(this.Userpower.form.newMenuPermissionIDs)
            },
            //权限修改
            Userpowerok(){
                let newMenuPermissionIDs = this.Userpower.form.newMenuPermissionIDs
                this.Userpower.form.newMenuPermissionIDs.forEach(t =>{
                    this.Userpower.data.forEach(o =>{
                        o.children.forEach(s =>{
                            if(s.id == t){
                                newMenuPermissionIDs.push(s.parent_id) 
                            }
                        })
                    })
                })
                newMenuPermissionIDs = [...new Set(newMenuPermissionIDs)]
                let base1 = new base();
                var params = new URLSearchParams();
                let myLord = this.$cookies.get("LoginName") +'|'+ this.$cookies.get("pwd")+'|'+ parseInt(new Date().getTime()/1000)+'|'+Math.round(Math.random()*100)+'|'+"8"
                params.append("myLord", base1.encode(myLord));
                params.append("editMPTypeVal", this.Userpower.form.editMPTypeVal); //  如果editMPType 为1时，这个值就是个人的perationUserGuid,如果是2的话，就是角色值:3代表合伙人客服 4代表财务
                params.append("partnerGuid", this.valuePa);
                params.append("editMPType", 1);  //如果从个人菜单权限进入，传1,  如果从角色菜单权限进入，传2
                params.append("userRealName", this.Userpower.form.userRealName);
                params.append("newMenuPermissionIDs", newMenuPermissionIDs.toString());
                this.$axios({
                    url: "http://139.224.204.55:7788/tlwewebapi/CityPartner/editMenuPermission",
                    method: "post",
                    data: params,
                    withCredentials: false
                }).then(res => {
                   this.Userpower.show = false
                   this.customerServiceList()
                })
            },
            userOperation(command) {
                switch (command) {
                    case "logout":
                    this.logout();
                    break;
                    case "editPsd":
                    if (this.$cookies.get("LoginType") == "1") {
                        this.$message.error(this.$t("message.marketNoPSD"));
                        return;
                    }
                    this.formm.oldpsd = "";
                    this.formm.newpsd = "";
                    this.formm.surepsd = "";
                    this.editPSDS = true;
                    break;
                    case "editSecPsd":
                    if (this.$cookies.get("LoginType") == "1") {
                        this.$message.error(this.$t("message.marketNoSecPSD"));
                        return;
                    }
                    this.formmSec.oldpsd = "";
                    this.formmSec.newpsd = "";
                    this.formmSec.surepsd = "";
                    this.editSecPSDS = true;
                    break;
                }
            },
            loadPartner() {
                var params = new URLSearchParams();
                params.append("languagecode", this.$i18n.locale);
                params.append("timestamp", this.GLOBAL.timestamp);
                params.append(
                    "securitykey",
                    md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
                );
                params.append("Token", this.$cookies.get("Token"));
                params.append("id", this.$cookies.get("ID"));
                params.append("loginType", this.$cookies.get("LoginType"));
                params.append("partnerno", this.$cookies.get("pno"));

                params.append("loginType", this.$cookies.get("LoginType"));
                params.append("pwd", this.$cookies.get("pwd"));
                params.append("LoginPwd", this.$cookies.get("pwd"));
                params.append("logid", this.$cookies.get("ID"));
                this.$axios({
                    url: "/PartnerRelated/BiNdiNg_PartneR",
                    method: "post",
                    data: params
                    //   headers: {
                    //     "Content-Type": "application/x-www-form-urlencoded"
                    //   }
                })
                .then(res => {
                    if (res.data.status == "success") {
                        this.partData = res.data.data;
                        var partV = this.$cookies.get("partner");
                        if (partV == null) {
                           this.valuePa = this.partData[0].partnerNo;
                        } else {
                           this.valuePa = this.$cookies.get("partner");
                        }
                        this.$cookies.set("partner", this.valuePa);
                        this.loadArea();
                    } else if (res.data.status == "re_login") {
                        this.soneIns = res.data.message;
                        this.dialogOuti = true;
                    } else {
                        this.$message.error(res.data.message);
                    }
                }).catch(err => {});
            },
            loadArea() {
                var params = new URLSearchParams();
                params.append("languagecode", this.$i18n.locale);
                params.append("timestamp", this.GLOBAL.timestamp);
                params.append(
                    "securitykey",
                    md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
                );
                params.append("Token", this.$cookies.get("Token"));
                params.append("id", this.$cookies.get("ID"));
                params.append("partnerno", this.$cookies.get("partner"));

                params.append("loginType", this.$cookies.get("LoginType"));
                params.append("pwd", this.$cookies.get("pwd"));
                params.append("logid", this.$cookies.get("ID"));
                params.append("LoginPwd", this.$cookies.get("pwd"));
                this.$axios({
                    url: "/PartnerRelated/BiNdiNg_PartneR_aReA",
                    method: "post",
                    data: params,
                    //   headers: {
                    //     "Content-Type": "application/x-www-form-urlencoded"
                    //   },
                    withCredentials: true
                })
                    .then(res => {
                    this.areaData = res.data.data;
                    var areaV = this.$cookies.get("areaValue");

                    if (areaV == null) {
                        this.valueAr = this.areaData[0].partnerareaguid;
                    } else {
                        for (var i = 0; i < this.areaData.length; i++) {
                        if (
                            this.areaData[i].partnerareaguid ==
                            this.$cookies.get("areaValue")
                        ) {
                            this.valueAr = this.$cookies.get("areaValue");
                        } else {
                            this.valueAr = this.areaData[0].partnerareaguid;
                        }
                        }
                    }
                    this.$cookies.set("areaValue", this.valueAr);
                    this.$cookies.set(
                        "dbMapCode",
                        this.areaData[0].dbmapcountryregioncode
                    );
                    this.$cookies.set("nation", this.areaData[0].nation);
                    if (this.$cookies.get("dbMapCode") == "jbsoon") {
                        this.dialogMap = true;
                    } else {
                        this.dialogMap = false;
                    }

                    if (
                        this.$cookies.get("areaValue") ==
                        "36204ede-e22e-436a-811f-9a48a879c7c3"
                    ) {
                        this.takePhoto = true;
                    } else {
                        this.takePhoto = false;
                    }
                    //调用接口
                    })
                    .catch(err => {
                    });
            },
            handleSizeChange(val){
               this.pagination.size = val
               this.customerServiceList()
            },
            handleCurrentChange(val){
               this.pagination.index = val
               this.customerServiceList()
            },
            serch(){
                this.customerServiceList()
            },
            // 新增
            add(){
                this.addinfo={
                    show:true,
                    form:{
                        myLord:'',
                        password:'',
                        newAccountName:'', // 登录系统的账号
                        newAccountLoginPWD:'', //登录系统的密码
                        newUserRealName:'', // 真实姓名
                        partnerGuid:'', // 运营区域id
                        idCardNO:'', //用户身份证
                        employeePhone:'', // 用户电话
                    },
                }
            },
            //新增确认
            addok(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let base1 = new base();
                        this.addinfo.form.partnerGuid = this.$cookies.get("partner")
                        this.addinfo.form.newAccountLoginPWD = md5( this.addinfo.form.password)
                        let myLordstring = this.$cookies.get("LoginName") +'|'+ this.$cookies.get("pwd")+'|'+ parseInt(new Date().getTime()/1000)+'|'+Math.round(Math.random()*100)+'|'+"54CPCP521~<Oops^>X4Abc#@gfdB_!~VVyY"
                        this.addinfo.form.myLord = base1.encode(myLordstring)
                        var params = new URLSearchParams();
                        params.append("myLord", this.addinfo.form.myLord);
                        params.append("newAccountName", this.addinfo.form.newAccountName);
                        params.append("newAccountLoginPWD", this.addinfo.form.newAccountLoginPWD);
                        params.append("newUserRealName", this.addinfo.form.newUserRealName);
                        params.append("partnerGuid", this.valuePa);
                        params.append("idCardNO", this.addinfo.form.idCardNO);
                        params.append("employeeType", '3');
                        params.append("employeePhone", this.addinfo.form.employeePhone);
                        this.$axios({
                            url: "http://139.224.204.55:7788/tlwewebapi/CityPartner/addStaff",
                            method: "post",
                            data: params,
                            withCredentials: false
                        }) .then(res => {
                            let ndata = res.data
                            if(ndata.status == 'success'){
                                this.$message({
                                    message: ndata.message,
                                    type: "success"
                                });
                                this.addinfo.show= false
                                this.customerServiceList()
                            }else{
                                this.$message.error(ndata.message);
                            }
                        })
                    }else{

                    }
                })

            },
            tabchange(){
                this.customerServiceList()
            },
            //启用禁用
            enableORdisableStaff(employeeStatus,itme){
                this.$confirm(employeeStatus==1?'是否启用该账户?':'是否禁用该账户?', employeeStatus ==1?"启用":"禁用", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        let base1 = new base();
                        var params = new URLSearchParams(); 
                        let myLord = this.$cookies.get("LoginName") +'|'+ this.$cookies.get("pwd")+'|'+ parseInt(new Date().getTime()/1000)+'|'+Math.round(Math.random()*100)+'|'+"abceefghijkmnmopqrsVVV!!4"
                        params.append("myLord", base1.encode(myLord));
                        params.append("perationUserGuid", itme.PerationUserGuid);
                        params.append("userRealName", itme.UserRealName);
                        params.append("employeeStatus", employeeStatus);
                        this.$axios({
                            url: "http://139.224.204.55:7788/tlwewebapi/CityPartner/enableORdisableStaff",
                            method: "post",
                            data: params,
                            withCredentials: false
                        }) .then(res => {
                            let ndata = res.data
                            if(ndata.status == 'success'){
                                this.$message({
                                    message: ndata.message,
                                    type: "success"
                                });
                                this.customerServiceList()
                            }else{
                                this.$message.error(ndata.message);
                            }
                        })
                    }).catch(() => {        
                });

            },
            // 列表
            customerServiceList(){
                let base1 = new base();
                var params = new URLSearchParams();
                let myLord = this.$cookies.get("LoginName") +'|'+ this.$cookies.get("pwd")+'|'+ parseInt(new Date().getTime()/1000)+'|'+Math.round(Math.random()*100)+'|'+"<XO666>v5Abc#@gfdB_!~544g?GFCCXxV1"
                params.append("myLord", base1.encode(myLord));
                params.append("pageIndex", this.pagination.index);
                params.append("pageSize", this.pagination.size);
                params.append("partnerGuid", this.valuePa || this.$cookies.get("partner"));
                params.append("newUserRealName", this.formInline.newUserRealName);
                params.append("employeePhone", this.formInline.employeePhone);
                params.append("employeeType", '3');
                params.append("employeeStatus", this.activeName); // 启用1 禁用 -1
                this.$axios({
                    url: "http://139.224.204.55:7788/tlwewebapi/CityPartner/staffList",
                    method: "post",
                    data: params,
                    withCredentials: false
                }) .then(res => {
                    let ndata = res.data
                    if(ndata.status == 'success'){
                       this.pagination.total = ndata.data.total
                       if(this.activeName == '1'){
                         this.useData = ndata.data.rows
                       }else{
                         this.NouseData = ndata.data.rows
                       }
                       
                    }
                    
                })
            },
        },
   }
</script>

<style lang="less" scoped>
    .flex{
        display: flex;
    }
    .aliecontent{
        align-content: center;
    }
    .marginleft{
        margin-left: auto;
    }
    .citypartnercspm{
      padding: 30px 0 0 22px;
      width: 97%;
      .add{
         height: 43px;
      }
        .CRMapsel {
            float: right;
            color: #000;
            padding-top: 12px;
        }
    }
</style>